import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/setting_option_selected.svg'
import _imports_1 from '@/assets/img/setting_option.svg'
import _imports_2 from '@/assets/img/setting_option_active.svg'


const _withScopeId = n => (_pushScopeId("data-v-a78cc0be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-[25px]" }
const _hoisted_2 = { class: "tw-flex tw-justify-between tw-items-center" }
const _hoisted_3 = { class: "tw-m-0 tw-text-[18px] tw-font-semibold tw-leading-[100%] tw-text-[#211F58]" }
const _hoisted_4 = {
  id: "vendor-assessment-template-group-btn",
  class: "group-button tw-flex tw-items-center"
}
const _hoisted_5 = { class: "tw-cursor-pointer" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_9 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_10 = { class: "information-container tw-flex tw-items-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "information tw-font-[13px] tw-flex tw-items-center tw-gap-2" }
const _hoisted_13 = ["id", "data-cy"]
const _hoisted_14 = ["id", "data-cy"]
const _hoisted_15 = { class: "tw-w-full tw-items-center tw-justify-start tw-inline-flex tw-gap-2 tw-ml-[50px]" }
const _hoisted_16 = { class: "tw-relative" }
const _hoisted_17 = { class: "tw-absolute" }
const _hoisted_18 = { class: "tw-p-[15px]" }
const _hoisted_19 = { class: "tw-text-[14px] tw-font-[500] tw-text-[#211F58]" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-[20px]"
}
const _hoisted_22 = ["id", "data-cy"]
const _hoisted_23 = { class: "tw-flex tw-items-center tw-justify-end tw-gap-[15px]" }
const _hoisted_24 = ["id", "data-cy", "onClick"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-[21px] tw-h-[5px]" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]

import CustomTableCanDropDrag from "@/components/common/customTableCanDropDrag.vue";
import { computed, ComputedRef, Ref, ref, watch } from "vue";
import popoverAssessment from "@/components/assessment/popoverAssessment.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { getComponentUiText } from "@/utils/utilities";
import StatusBadge from "../common/setting/statusBadge.vue";
import store from "@/store";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Vendor } from "@/services/apiRoutes/routes";
import { getSessionPortal } from "@/services/subscriptions";
import {
  ARE_YOU_SURE_TYPES,
  MODAL_NAME,
  templateType,
} from "@/utils/constants";
import router from "@/router";
import { IModalMessage } from "@/interfaces/common/common";
import { updateRequestedTemplate } from "@/services/vendor";
import { DRAG_AND_DROP_TABLE_TYPE } from "@/utils/constants";
import cloneDeep from "lodash/cloneDeep";
import { getOrgDetails } from "@/services/org";
import IconButton from "@/components/common/iconButton.vue";
import AssessmentDisplayOptions from "@/components/assessment/assessmentDisplayOptions.vue";
import { Org } from "@/services/apiRoutes/routes";
import CustomDropDownItem from "../common/customDropDownItem.vue";

export type dataActionTableColumn = {
  id: any;
  title: string;
  scoreIncreaseTotal: number;
  scoreIncreaseFirstCount: number;
  riskReduction: "High" | "Significant";
};


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentTemplate',
  props: {
  tableData: {
    type: Array as () => any[],
    default: () => [],
  },
},
  emits: [
  "update-selected-rows",
  "select:row",
  "delete:assessment",
  "create:assessment",
  "refresh",
  "update:assessment",
],
  setup(__props, { emit }) {

const props = __props;



const tableFields = [
  {
    text: getComponentUiText("app-component-custom-table-header-name-1"),
    value: "name",
    headerClass:
      "tw-text-[#fff] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase tw-pl-[3px]",
    sortable: false,
    valueClass: "tw-w-[200px] !tw-pr-[16px] !tw-py-[15px] !tw-pl-[3px]",
    font13: true,
  },
  {
    text: getComponentUiText(
      "app-assess-assessment-modal-create-update-description-1",
    ),
    value: "templateDescription",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase  tw-w-[200px]",
    render: (value: string) =>
      `<span class="tw-text-[#231F20] tw-text-[12px] tw-not-italic tw-font-medium tw-leading-[normal]">${value}</span>`,
    sortable: false,
    font13: true,
    valueClass:
      "tw-w-[300px] !tw-text-[#231F20] !tw-text-[12px] !tw-pr-[16px] !tw-py-[15px]",
    textAlign: false,
  },
  {
    text: getComponentUiText(
      "app-assess-assessment-modal-manage-template-column-type-1",
    ),
    value: "templateType",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase tw-flex tw-items-center tw-justify-start tw-ml-[50px]",
    render: (value: string) =>
      `<span class="tw-text-[#212529] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal]">${value}</span>`,
    sortable: false,
    valueClass: "tw-w-[150px] !tw-py-[15px]",
    font13: true,
  },
  {
    text: getComponentUiText(
      "app-assess-assessment-modal-create-update-questions-1",
    ),
    value: "questions",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase tw-flex tw-items-center tw-justify-center",
    render: (value: string) =>
      `<span class="tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal]">${value}</span>`,
    sortable: false,
    font13: true,
    valueClass: "tw-w-[20px] !tw-pr-[16px] !tw-py-[15px]",
    textAlign: true,
  },
  {
    text: "",
    value: "action",
    headerClass: "",
    valueClass: "!tw-pr-[25px] !tw-py-[15px]",
  },
];

const handleDeleteAssessment = (item: any) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-assess-assessment-modal-delete-template-title-1",
      ),
      description: getComponentUiText(
        "app-assessments-vendor-assessment-description-delete-template-modal-1",
        false,
        { name: item.name },
      ),

      list: [],
      buttonText: getComponentUiText(
        "app-settings-domain-verify-modal-delete-button-1",
      ),

      isShowBtnCancel: true,
      buttonRed: true,
      hiddenHelp: false,
      type: ARE_YOU_SURE_TYPES.assessmentTemplateDelete,
    },
    events: {
      "update:data": async () => {
        store.dispatch(
          "LoadingAreYouSureButtonModal/setLoadingRedButton",
          true,
        );
        try {
          const res = await updateRequestedTemplate({
            templateId: item.id,
            params: {
              isArchived: true,
            },
          });
          if (res.status === 200) {
            showSuccessToast(
              getComponentUiText(
                "app-assessment-vendor-delete-templates-successfully-1",
              ),
            );
            await store.dispatch("Vendor/fetchRequestedTemplate");
          }
        } catch (error) {
          showErrorAPI(error, Vendor.putChecklistRequestedTemplate);
        } finally {
          store.dispatch(
            "LoadingAreYouSureButtonModal/setLoadingRedButton",
            false,
          );
        }
      },
    },
  };

  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
};

const handleEditTemplateAssessment = (item: any) => {
  router.push({
    path: "/assess/vendor/template",
    query: { isEdit: "true", templateId: item.id },
  });
  emit("update:assessment", item);
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
};

const handleSelectTemplate = (selectedIds: number[]) => {
  const data = selectedIds.map((id) =>
    props.tableData.find((item) => item.id === id),
  );
  emit("select:row", data);
};

const items = [
  {
    text: "app-assess-assessment-modal-btn-edit-template-assessment-1",
    dataCy: "vendor-assess-manage-edit-template-assessment-btn",
    arrowRed: false,
    action: handleEditTemplateAssessment,
  },
  {
    text: "app-assess-assessment-modal-delete-template-title-1",
    dataCy: "vendor-assess-manage-delete-template-assessment-btn",
    arrowRed: true,
    action: handleDeleteAssessment,
  },
];

const orgsList = computed(() => store.state.Org.orgsList);
const isHoverDisplayOptions: Ref<boolean> = ref(false);
const isShowToolTipDisplayOptions: Ref<boolean> = ref(false);
const popover_display_options: any = ref(null);
const idItemExpland = ref(null);
const isLoadingTemplateDetail = ref(false);

const showArchivedTemplate: Ref<boolean> = ref(
  store.state.Vendor.isShowArchivedTemplate,
);

const showHomeOrgTemplate: Ref<boolean> = ref(
  store.state.Vendor.includeHomeOrgTemplate,
);

const isCheckToggleDisplayOptions: Ref<boolean> = computed(() => {
  const orgId = currentOrg.value.orgId;
  const isHomeOrg = orgsList.value.find((item) => item.id === orgId)?.isHome;

  if (isHomeOrg) return showArchivedTemplate.value;
  else return showArchivedTemplate.value || showHomeOrgTemplate.value;
});

const handleShowArchivedTemplate = async () => {
  showArchivedTemplate.value = !showArchivedTemplate.value;

  await store.commit(
    "Vendor/SET_IS_SHOW_ARCHIVED_TEMPLATES",
    showArchivedTemplate.value,
  );

  await store.dispatch("Vendor/fetchRequestedTemplate");
};

const handleShowHomeOrgTemplate = async () => {
  showHomeOrgTemplate.value = !showHomeOrgTemplate.value;

  await store.commit(
    "Vendor/SET_INCLUDE_HOME_ORG_TEMPLATE",
    showHomeOrgTemplate.value,
  );

  await store.dispatch("Vendor/fetchRequestedTemplate");
};

const displayOptions: ComputedRef = computed(() => {
  const orgId = currentOrg.value.orgId;
  const homeOrg = orgsList.value.find((item) => item.isHome);

  const displayOptionsIsOrgHome = ref([
    {
      title: getComponentUiText(
        "app-component-vendor-assessment-display-options-show-archived-template-1",
      ),
      value: showArchivedTemplate.value,
      action: handleShowArchivedTemplate,
    },
  ]);

  const displayOptionsIsNotOrgHome = ref([
    {
      title: getComponentUiText(
        "app-component-vendor-assessment-display-options-show-archived-template-1",
      ),
      value: showArchivedTemplate.value,
      action: handleShowArchivedTemplate,
    },
    {
      title: getComponentUiText(
        "app-component-vendor-assessment-display-options-show-home-org-template-1",
        false,
        { orgHomeName: homeOrg?.name || "" },
      ),
      value: showHomeOrgTemplate.value,
      action: handleShowHomeOrgTemplate,
    },
  ]);

  return homeOrg?.id === orgId
    ? displayOptionsIsOrgHome.value
    : displayOptionsIsNotOrgHome.value;
});

const descriptionTemplate: any = ref(
  getComponentUiText(
    "app-assess-assessment-manage-template-modal-description-tooltip-plan-1",
    false,
    {
      linkText: getComponentUiText(
        "app-assess-assessment-manage-template-modal-btn-click-here-1",
      ),
    },
    true,
  ),
);

const routerSubscription = async (event) => {
  if (event.target.id === "upgrade-link") {
    event.preventDefault();
    try {
      {
        const clientSecretResponse = await getSessionPortal("dashboard");
        const sessionPortalUrl =
          clientSecretResponse.data?.data?.redirectUrl || "";
        window.open(sessionPortalUrl, "_blank");
        if (!sessionPortalUrl) {
          showErrorAPI("app-settings-subscription-error-text-1", "error");
          return;
        }
        return;
      }
    } catch (error) {
      // showErrorAPI(error, Subscription.getSessionPortal);
    }
  }
};



const isLoadinggetRequestedTemplate = computed(() => {
  return store.state.Vendor.isLoadinggetRequestedTemplate;
});

const reorderList = async (data) => {
  try {
    const minOrder = tableDataFormatted.value[0].templateOrder;
    let order = minOrder || minOrder < 0 ? 0 : minOrder - 1;
    const promises: any = [];
    tableDataFormatted.value.forEach((item, index) => {
      if (item.templateOrder === null || item.templateOrder <= order) {
        order = order + 1;
        item.templateOrder = order;
        if (item.templateType !== templateType.system) {
          promises.push(
            updateRequestedTemplate({
              templateId: item.id,
              params: {
                order,
              },
            }),
          );
        }
      } else {
        order = item.templateOrder;
      }
    });
    await Promise.all(promises);

    store.commit("Assessment/REORDER_LIST_TEMPLETE", data);
  } catch (error) {
    showErrorAPI(error, Vendor.putChecklistRequestedTemplate);
  }
};

const openModalCreateNewVendorAssessment = (item) => {
  const emitData = {
    component: MODAL_NAME.MODAL_CREATE_NEW_VENDOR_ASSESSMENT,
    properties: {
      value: {},
      title: "",
      description: "",
      buttonText: "",
      buttonRed: false,
      slotCustom: "",
      list: [],
      hiddenHelp: "",
      templateId: item,
    },
    events: {
      "update:data": () => {
        emit("refresh");
      },
      "update:close": () => {},
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const tableDataFormatted: any = ref([]);
const currentOrg = computed(() => store.state.Org.currentOrg);
const checklistRequestedTemplate = computed(() => {
  return store.state.Vendor.checklistRequestedTemplate;
});

watch(
  () => [checklistRequestedTemplate.value, currentOrg.value],
  (newValue) => {
    if (!currentOrg.value.id) return;
    const data = checklistRequestedTemplate.value.map((item) => {
      let type = "";
      if (item.templateOrgId && item.templateOrgId !== currentOrg.value.id) {
        getNameCode(item.templateOrgId);
      }
      switch (true) {
        case item.templateOrgId === null:
          type = getComponentUiText(
            "app-assess-assessment-manage-template-modal-type-system-1",
          );
          break;
        case item.templateOrgId === currentOrg.value.id:
          type = getComponentUiText(
            "app-assess-assessment-manage-template-modal-type-org-1",
          );
          break;
        case Boolean(item.templateOrgId):
          type = nameCode.value.toUpperCase();
          break;
        default:
          type = "";
      }
      return {
        id: item.templateId,
        name: item.templateName,
        templateType: type,
        version: item.templateVersion,
        ...item,
      };
    });
    tableDataFormatted.value = cloneDeep(data);
  },
);
const nameCode: Ref = ref("");
const getNameCode = async (orgId) => {
  try {
    const res = await getOrgDetails(orgId);
    nameCode.value = res.data.data.nameCode;
  } catch (error) {
    showErrorAPI(error, Org.getOrg);
  }
};
const openPopoverDisplayOption = () => {
  setTimeout(() => {
    popover_display_options?.value?.$emit("show");
  }, 500);
};

const createNewTemplate = () => {
  store.commit("Vendor/SET_CHECKLIST_REQUESTED_TEMPLATE_DETAIL_BY_ID", []);
  router.push({ path: "/assess/vendor/template" });
};

return (_ctx: any,_cache: any) => {
  const _component_b_popover = _resolveComponent("b-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
            "app-assessment-assessment-vendor-assessment-templates-1",
          )), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            id: "manage-vendor-template-display-settings popover-target-1",
            class: _normalizeClass(["toggle-switch-view tw-relative tw-px-[14px] tw-py-[10px] !tw-mr-[20px]", isCheckToggleDisplayOptions.value ? 'setting-option-selected' : '']),
            onClick: openPopoverDisplayOption,
            onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHoverDisplayOptions.value = true)),
            onMouseout: _cache[1] || (_cache[1] = ($event: any) => (isHoverDisplayOptions.value = false))
          }, [
            _createElementVNode("label", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                (isCheckToggleDisplayOptions.value)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                  : (
                  !isShowToolTipDisplayOptions.value && !isHoverDisplayOptions.value
                )
                    ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                    : (_openBlock(), _createElementBlock("img", _hoisted_9))
              ])
            ])
          ], 34),
          _createVNode(IconButton, {
            id: "vendor-assess-template-btn-open-modal-create",
            "data-cy": "vendor-assess-manage-btn-open-modal-add-template",
            src: "/img/plus_icon.svg",
            onClick: createNewTemplate
          })
        ])
      ]),
      _createVNode(CustomTableCanDropDrag, {
        columns: tableFields,
        draggable: true,
        "is-loading": isLoadinggetRequestedTemplate.value,
        data: tableDataFormatted.value,
        "height-tb": true,
        reorderable: true,
        "id-item-expland": idItemExpland.value,
        "skeleton-row-number": 3,
        "custom-class": `vendor-table`,
        "table-type": _unref(DRAG_AND_DROP_TABLE_TYPE).VENDORTEMPLATE,
        "empty-text": 
        _unref(getComponentUiText)('app-component-assessments-templates-table-empty-1')
      ,
        onMoved: reorderList,
        onUpdateSelectedRows: _cache[2] || (_cache[2] = ($event: any) => (handleSelectTemplate($event)))
      }, {
        "cell(name)": _withCtx((data) => [
          _createElementVNode("div", _hoisted_10, [
            (data.value?.imgSrc)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: data.value?.imgSrc,
                  alt: "person_random"
                }, null, 8, _hoisted_11))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", {
                id: `vendor-assessment-template-name-${data.item.id}`,
                "data-cy": `vendor-assess-manage-template-table-template-name-${data.item.id}`,
                style: {"color":"#211f58","font-size":"13px","font-style":"normal","font-weight":"500","line-height":"normal"},
                class: "name-value"
              }, _toDisplayString(data.value), 9, _hoisted_13)
            ])
          ])
        ]),
        "cell(templateDescription)": _withCtx((data) => [
          _createElementVNode("div", {
            id: `vendor-assessment-template-description-${data.item.id}`,
            "data-cy": `vendor-assess-manage-template-table-template-description-${data.item.id}`,
            class: "information-container tw-flex tw-items-center"
          }, _toDisplayString(data.value), 9, _hoisted_14)
        ]),
        "cell(templateType)": _withCtx((data) => [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(StatusBadge, {
                label: data.value,
                "is-check-plan": 
                data.item.templatePlanEntitled ||
                data.item.templateOrgId !== null
              ,
                "is-template-org": data.item.templateOrgId !== null,
                "class-current-user": 'tw-text-[#387dff] tw-leading-[130%] tw-bg-white tw-border tw-border-solid tw-border-[#e4f1ff] tw-rounded-[5px] tw-text-[13px] tw-font-[500]',
                "data-cy": `vendor-assess-manage-template-table-template-type-${data.item.id}`,
                value: data.value
              }, null, 8, ["label", "is-check-plan", "is-template-org", "data-cy", "value"]),
              _createElementVNode("span", _hoisted_17, [
                (!data.item.templatePlanEntitled)
                  ? (_openBlock(), _createBlock(ButtonShowDuplicateAssessment, {
                      key: 0,
                      "id-popover": 'popover' + Math.random() * 1000,
                      "custom-class": 'tw-w-[max-content]  md:tw-max-w-[350px] lg:tw-max-w-[470px] ',
                      classes: `!tw-leading-none tw-ml-2`
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(getComponentUiText)(
                        "app-assess-assessment-manage-template-modal-title-tooltip-plan-1",
                      )), 1),
                          _createElementVNode("div", {
                            class: "tw-py-[10px] tw-text-[13px] tw-font-[400] tw-text-[#878787]",
                            onClick: routerSubscription,
                            innerHTML: descriptionTemplate.value
                          }, null, 8, _hoisted_20)
                        ])
                      ]),
                      _: 1
                    }, 8, ["id-popover"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        "cell(questions)": _withCtx((data) => [
          (isLoadingTemplateDetail.value && data.item.id === idItemExpland.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                id: `vendor-assessment-template-question-count-${data.item.id}`,
                "data-cy": `vendor-assess-manage-template-table-template-questions-${data.item.id}`,
                style: {"color":"var(--UI-dark-grey, #878787)","text-align":"center","font-family":"Poppins","font-size":"13px","font-style":"normal","font-weight":"400","line-height":"normal"},
                class: "tw-w-full tw-items-center tw-justify-center tw-inline-flex"
              }, _toDisplayString(data.item.itemCount), 9, _hoisted_22))
        ]),
        "cell(action)": _withCtx((data) => [
          _createElementVNode("div", _hoisted_23, [
            (data.item?.itemCount > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  id: `vendor-assessment-template-use-template-${data.item.id}`,
                  "data-cy": `vendor-assess-manage-use-template-btn-${data.item.id}`,
                  class: _normalizeClass(`tw-h-[36px] tw-w-fit tw-truncate tw-whitespace-nowrap tw-select-none tw-cursor-pointer tw-flex tw-px-[20px] tw-py-[8px] tw-rounded-[100px] tw-text-[#387DFF] 
                tw-bg-[#FFF] tw-text-center tw-text-[13px] tw-not-italic tw-font-medium tw-leading-normal tw-border tw-border-solid tw-border-[#EFF0F1]`),
                  onClick: 
              () => openModalCreateNewVendorAssessment(data.item.templateId)
            
                }, _toDisplayString(_unref(getComponentUiText)(
                "app-assessments-vendor-assessment-use-template-button-1",
              )), 9, _hoisted_24))
              : _createCommentVNode("", true),
            (data.item.templateType !== _unref(templateType).system)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  (data.item.templatePlanEntitled)
                    ? (_openBlock(), _createBlock(popoverAssessment, {
                        key: 0,
                        "style-button": "!tw-py-[10px] !tw-px-[10px] tw-ml-[-10px] tw-mr-[-10px] tw-items-center tw-justify-center",
                        offset: 20,
                        "id-popover": `vendor-assessment-template-popover-${data.item.id}`,
                        "data-cy-id": `vendor-assess-manage-template-table-meatballs-${data.item.id}`
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item, index) => {
                            return _createVNode(CustomDropDownItem, {
                              id: `vendor-assessment-template-popover-item-${data.item.id}-${index}`,
                              key: `option_vendor_template_${index}`,
                              "id-text": `${item.text}`,
                              "data-cy-id": `${item.dataCy}-${data.item.id}`,
                              "custom-text-class": `tw-w-[90%] !tw-text-[13px] !tw-font-normal !tw-leading-[19.5px] ${
                  item.arrowRed ? 'tw-text-[#F7553C]' : ''
                } tw-whitespace-normal`,
                              "arrow-icon-style": `${
                  item.arrowRed ? 'tw-text-[#F7553C]' : 'tw-text-[#387DFF]'
                } tw-min-w-[7px]`,
                              padding: 'tw-px-[13px] tw-py-[12px]',
                              "custom-class": 'tw-flex tw-justify-between tw-items-center !tw-border-0',
                              onClick: () => item.action(data.item)
                            }, null, 8, ["id", "id-text", "data-cy-id", "custom-text-class", "arrow-icon-style", "onClick"])
                          }), 64))
                        ]),
                        _: 2
                      }, 1032, ["id-popover", "data-cy-id"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
          ])
        ]),
        _: 1
      }, 8, ["is-loading", "data", "id-item-expland", "table-type", "empty-text"])
    ]),
    _createVNode(_component_b_popover, {
      ref_key: "popover_display_options",
      ref: popover_display_options,
      target: "manage-vendor-template-display-settings popover-target-1",
      placement: "bottom-end",
      click: "true",
      offset: 20,
      style: {"max-width":"290px !important"},
      "custom-class": `custom-actions-popover assessment-display-options`,
      class: "tw-absolute",
      onShow: _cache[3] || (_cache[3] = ($event: any) => (isShowToolTipDisplayOptions.value = true)),
      onHidden: _cache[4] || (_cache[4] = ($event: any) => (isShowToolTipDisplayOptions.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(AssessmentDisplayOptions, {
          "list-option": displayOptions.value,
          class: _normalizeClass('!tw-w-[290px]')
        }, null, 8, ["list-option"])
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})